import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const EmailInput = () => {
  return (
    <VpHookFormInput maxLength={100} required isEmail name="email" placeholder="Email Address" />
  );
};

export default EmailInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-in/EmailInput.jsx